import { render, staticRenderFns } from "./Sorting.vue?vue&type=template&id=d4368dce&scoped=true"
import script from "./Sorting.vue?vue&type=script&lang=js"
export * from "./Sorting.vue?vue&type=script&lang=js"
import style0 from "./Sorting.vue?vue&type=style&index=0&id=d4368dce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4368dce",
  null
  
)

export default component.exports